// gsap.registerPlugin(ScrollTrigger);

// const panels = gsap.utils.toArray(".panel");

// panels.forEach((panel, i) => {
//   if (panels[i + 1]) {
//     ScrollTrigger.create({
//       trigger: "#main",
//       start: "top+=" + 100 * (i + 1) + "%" + " top",
//       end: "top+=" + 90 * (i + 1) + "%" + " top",
//       id: i,
//       onEnter: () => {
//         gsap
//           .timeline()
//           .to(panel, {
//             scale: 0.8,
//             autoAlpha: 0,
//             borderRadius: "300px",
//             duration: 0.9
//           })
//           .to(
//             panels[i + 1],
//             {
//               scale: 1,
//               autoAlpha: 1,
//               borderRadius: "0",
//               duration: 0.9
//             },
//             "<"
//           );
//       },
//       onEnterBack: () => {
//         gsap
//           .timeline()
//           .to(panel, {
//             scale: 1,
//             autoAlpha: 1,
//             borderRadius: "0",
//             duration: 0.9
//           })
//           .to(
//             panels[i + 1],
//             {
//               scale: 0.8,
//               autoAlpha: 0,
//               borderRadius: "300px",
//               duration: 0.9
//             },
//             "<"
//           );
//       }
//     });
//   }
// });

// ScrollTrigger.create({
//   trigger: "#main",
//   pin: true,
//   end: "+=" + panels.length * 100 + "%"
// });

$( function() {
    $( "#tabs" ).tabs();
} );

// var swiper = new Swiper('.swiper-review', {
//     nextButton: '.swiper-button-next',
//     prevButton: '.swiper-button-prev',       
//     breakpoints: { 
//         768: {
//             slidesPerView: 1,
//             effect: 'fade',
//         },
//     }
// });

// control
var controleft = new Swiper('.control-left', {    
    direction: 'vertical',
    speed:800,
    slidesPerView: 1,
    paginationClickable: true,
    mousewheelControl: true
});
var controlRight = new Swiper('.control-right', {
    speed:800,
    effect : 'fade',
    fade: {
        crossFade: true,
    },
});
var controlHidden = new Swiper('.control-hidden', {
    pagination: '.swiper-pagination',
    direction : 'vertical',
    followFinger : false,
    speed:800,
    mousewheelControl : true,
    control: [controleft, controlRight],
});

// var swiper2 = new Swiper('.swiper-review-desktop', {
//     nextButton: '.swiper-button-next',
//     prevButton: '.swiper-button-prev',
//     slidesPerView: 4,
//     spaceBetween: 40,
//     speed:800,
//     breakpoints: { 
//         998: {
//             spaceBetween: 20,
//         },
//     }
// });
// control end

var swiper6 = new Swiper('.swiper-hover-2', {
    effect : 'fade',    
    fade: {
        crossFade: true,
    }
});
var swiper7 = new Swiper('.swiper-hover', {
    direction : 'vertical',
    followFinger : false,
    speed:800,
    mousewheelControl : true,   
});
 var swiper9 = new Swiper('.slide-hovers', {
    // pagination: '.swiper-pagination',
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    // direction : 'vertical',
    speed:800,
    // mousewheelControl : true,
    control: [swiper7, swiper6],
 });

// popup
$('.orange').click(function(){ 
    $('.pop-up').fadeIn();
});
$('.modal__close-button').click(function(){ 
    $('.pop-up').fadeOut();
    $('.pop-up2').fadeOut();
    $('.iframe-pop').fadeOut();
});
$('.popup-btn').click(function(){ 
    $('.pop-up2').fadeIn();
});
$('.icon-btn').click(function(){ 
    $('.iframe-pop').fadeIn();
});

// spacer-4 mobile
var Swiper3 = new Swiper('#swiper-container1',{
    slideToClickedSlide:true,
    centeredSlides : true,
    slidesPerView : 2,
    speed:500,
})
var Swiper4 = new Swiper('#swiper-container2',{
    speed:500,
    
})
Swiper3.params.control = Swiper4;
Swiper4.params.control = Swiper3;

AOS.init({
	easing: 'ease-out-back',
	duration: 1000
});

setTimeout(function(){
    var menu = document.getElementById("ms-explode");
    var titleTop = menu.offsetTop;
    window.addEventListener("scroll", function(){
        var btop = document.body.scrollTop || document.documentElement.scrollTop;
        if (btop = titleTop) {
          // 为导航条设置fix
          $("#ms-explode").addClass("ms-explode-active");
        } else {
           //移除
          $("#ms-explode").removeClass("ms-explode-active");
        }
    })  
},1000)

$(window).scroll(function() {
    var scrollDistance = $(window).scrollTop(); 
    if (scrollDistance > 300) { 
      $(".header-nav").addClass("header-nav-sticky");
    } else {
       $(".header-nav").removeClass("header-nav-sticky");
    }
});

$(document).on('click', '.title-faq', function(){
    $(this).toggleClass("faq_icon_open")
    $(this).siblings().toggleClass("swiper-slide-open");
});


